import React, { useEffect, useContext, useRef } from 'react'
import { select, selectAll } from 'd3-selection'
import triangles, {
    axisLabels,
    tickLabels,
    triangleFilllines,
} from './triangles'
import { DataContext } from '../DataContext'
import { xScale, yScale } from '../utility/scales'

const Lines = ({ svgRef }) => {
    const { containerDimensions } = useContext(DataContext)
    return (
        <g >
            Outer Lines
            {triangles.map((t, idx) => (
                <line
                    key={idx}
                    style={{ strokeWidth: 2 }}
                    stroke={`black`}
                    x1={xScale(t.x0, containerDimensions.width)}
                    y1={yScale(t.y0, containerDimensions.height)}
                    x2={xScale(t.x1, containerDimensions.width)}
                    y2={yScale(t.y1, containerDimensions.height)}
                />
            ))}
            //inner thin lines
            {triangleFilllines().map((t, idx) => (
                <line
                    key={idx}
                    style={{ strokeWidth: 0.5 }}
                    stroke={`gray`}
                    stroke-dasharray={'5,1'}
                    x1={xScale(t.x0, containerDimensions.width)}
                    y1={yScale(t.y0, containerDimensions.height)}
                    x2={xScale(t.x1, containerDimensions.width)}
                    y2={yScale(t.y1, containerDimensions.height)}
                />
            ))}
            {[...tickLabels, ...axisLabels].map((l, idx) => (
                <text
                    transform={`translate(${xScale(l.x, containerDimensions.width)}, ${yScale(l.y, containerDimensions.height)}), rotate(${l.rot})`}
                    key={idx}
                    style={{ ...l.style, userSelect: 'none', textAnchor: 'middle' }}
                    fill="black"
                >
                    {l.text}
                </text>
            ))}
        </g>
    )
}

export default Lines
